import {getField, updateField} from 'vuex-map-fields';
import UserModule from '@/commonFunction/consumerModule'

let current_module = new UserModule('/ws/users/user/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'UUID', value: 'uid', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'ID', value: 'id', sortable: true, filterable: true, divider: true,},
        {text: 'Username', value: 'username', sortable: true, filterable: true, divider: true,},
        {text: 'Shortname', value: 'shortname', sortable: true, filterable: true, divider: true,},
        {text: 'Human user', value: 'human_user', sortable: false, filterable: true, divider: true,},
        {text: 'Employee number', value: 'employee_number', sortable: false, filterable: true, divider: true,},
        {text: 'Last name', value: 'last_name', sortable: true, filterable: true, divider: true,},
        {text: 'Email', value: 'email', sortable: true, filterable: true, divider: true,},
        {text: 'Is staff', value: 'is_staff', sortable: true, filterable: true, divider: true, type: 'bool'},
        // {text: 'Is active', value: 'is_active', sortable: true, filterable: true, divider: true, type: 'bool'},
        {text: 'Is superuser', value: 'is_superuser', sortable: true, filterable: true, divider: true, type: 'bool', width: 50},
        {text: 'Groups', value: 'groups', sortable: true, filterable: true, divider: true},

        {text: 'Last logon', value: 'last_login', sortable: true, divider: true, type: 'datetime', width: 110},
        {text: 'Date join', value: 'date_join', sortable: true, divider: true, type: 'datetime', width: 110},
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        UserTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}